import module from './vuex'

const registerStore = store => {
  store.registerModule('MCT_LOADER', { ...module })
}

export default registerStore
